module.exports = __webpack_public_path__ + "static/assets/f4473b594bb6b8ef7266f7b37f4392e5.png";